import React from 'react';
import moment from 'moment';

export default function statusDate(status, completedOn, css, updatedOn) {
  if (status === 'completed') {
    if (completedOn) {
      return (
        <div className={css.progressBarBottomRight}>
          <p className={css.progressBarBottomRightHeadline}>Completed On</p>
          <p className={css.progressBarBottomRightDate}>
            {completedOn
              ? moment(new Date(completedOn)).format('MM/DD/YY HH:MM a')
              : ''}
          </p>
        </div>
      );
    } else {
      return null;
    }
  } else if (status !== 'completed') {
    return (
      <div className={css.progressBarBottomRight}>
        <p className={css.progressBarBottomRightHeadline}>Updated On</p>
        <p className={css.progressBarBottomRightDate}>
          {updatedOn
            ? moment(new Date(updatedOn)).format('MM/DD/YY HH:MM a')
            : ''}
        </p>
      </div>
    );
  } else {
    return null;
  }
}
